import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "user-message" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "prompt" }
const _hoisted_5 = { class: "icon row-hvcenter" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "pulse-item"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_PulseItem = _resolveComponent("PulseItem")
  const _component_Skeleton = _resolveComponent("Skeleton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["message", {[$props.mode]: true}])
    }, [
      ($props.mode === 'expanded')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", null, [
              _createVNode(_component_Icon, {
                class: "icon",
                width: "1.6rem",
                height: "1.6rem",
                icon: "open-quote"
              })
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", { innerHTML: $options.text }, null, 8 /* PROPS */, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_IconAsButton, {
                  hoverable: "",
                  icon: "package-plus",
                  size: "2rem",
                  "stroke-width": "1",
                  tooltip: "Save prompt",
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('prompt-save')))
                })
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : ($props.mode === 'onboarding')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Icon, {
                    width: "1.3rem",
                    height: "1.3rem",
                    icon: "open-quote"
                  })
                ])
              ]),
              _createElementVNode("span", {
                class: "text",
                innerHTML: $options.text
              }, null, 8 /* PROPS */, _hoisted_6)
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    ($data.show_pulse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (!!$data.pulse_item)
            ? (_openBlock(), _createBlock(_component_PulseItem, {
                key: 0,
                item: $data.pulse_item,
                static: true
              }, null, 8 /* PROPS */, ["item"]))
            : (_openBlock(), _createBlock(_component_Skeleton, {
                key: 1,
                style: {"height":"20rem","border-radius":"1.2rem"}
              }))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}